import React, { useState } from 'react'
import Button from '@material-ui/core/Button'

import {
  withDataProvider,
  showNotification,
  GET_LIST
} from 'react-admin'

import { createStyles, WithStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { ASSIGN_EXPERT } from '../../providers/constants'
import UsersSelect from '../UsersSelect'
import FormDialog from "../FormDialog";
import DeactivateSegmentModal from "../../components/Segments/DeactivateSegmentModal";

const styles = () => createStyles({
  wrap: {
    display: 'flex',
    width: '700px',
    marginBottom: '20px',
  },
  elements: {
    marginRight: '25px',
  },
  buttonWrap: {
    width: '596px',
    textAlign: 'right',
  },
  textAreaWrap: {
    marginBottom: '15px',
  },
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

const ToolbarDeveloper = withStyles(styles)(({classes, dataProvider, dispatch, statusId, specializationId, disabled, segments, checkedData}: any) => {

  const [users, setUsers] = useState([])

  const assignExpert = async (statusId, selectId, successText: boolean | string = false) => {
    const currentUserId = (document.getElementById(selectId) as HTMLInputElement).value as unknown

    if (currentUserId > 0) {
      await dataProvider(ASSIGN_EXPERT, 'segments', {
        segmentId: segments,
        data: {
          toUserId: currentUserId,
          status: 'assign',
          segmentStatusId: statusId // id assign
        }
      }, successText ? {
        onSuccess: {
          notification: { body: successText, level: 'info' },
        },
        onFailure: {
          notification: { body: 'Error', level: 'warning' },
        },
        refresh: true
      } : responseSuccess)
    } else {
      dispatch(showNotification('Эксперт не выбран', 'warning'))
    }
  }

  const checkNewExpert = async selectId => {
    const newExpert = (document.getElementById(selectId) as HTMLInputElement).value as unknown
    const error = []
    let checked = false

    // const segmentInfo = await dataProvider(GET_LIST, 'segments', {
    //   filter: { id: segments.join(',') },
    //   url: 'segments'
    // })
    //
    // segmentInfo.data.map((segment, key) => {
    //   segment.experts.map(item => {
    //     if (item.id as number == newExpert as number) {
    //       checked = true
    //       error.push(`Данный пользователь уже проверял сегмент №${segment.id}, подтвердите повторное назначение эксперта.`)
    //     }
    //   })
    //   if (segment.verifyStatusId === 2) {
    //     error.push(`Cегмент №${segment.id} находится в работе, вы уверены что хотите его переназначить?`)
    //   }
    // })

    return {
      result: checked,
      error,
    }
  }

  /**
   * Получает список пользователей по фильтру.
   * @param filter
   */
  const getUsers = async filter => {
    const result = await dataProvider(GET_LIST, 'users', {filter: filter})
    setUsers(result.data)
  }

  /**
   * Перевести в указанный статус.
   * @param statusId
   * @param successText
   */
  const setStatus = async (statusId, successText: boolean | string = false) => {
    let isValid = true

    if (segments.length > 1) {
      const checkedItems: Array<ISegment> = Object.values(checkedData)
      isValid = checkedItems.every(({ statusId }, i, array) => statusId === array[0].statusId)
    }

    if (isValid) {
      dataProvider(ASSIGN_EXPERT, 'segments', {
        segmentId: segments,
        data: {
          status: 'assign',
          segmentStatusId: statusId
        }
      }, { onSuccess: { refresh: true } }).then(() => {
        dispatch(showNotification(successText))
      }).catch(error => {
        dispatch(showNotification(error, 'warning'))
      })
    } else {
      dispatch(showNotification('Сегменты должны быть в одном статусе.', 'warning'))
    }
  }

  return (
    <></>
  )
})

export default withDataProvider(ToolbarDeveloper)
